export default __webpack_public_path__ + "b9dd171ca69207620e963bde9417848a.jpg";